'use strict';

module.exports = function cleanText(string) {
    return string.replace(/<+$/g, '').replace(/</g, ' ');
}


//////////////////
// WEBPACK FOOTER
// ./src/util/cleanText.js
// module id = 7
// module chunks = 0